import React from "react";
import ReviewPropertyInspection from "./components/reviewPropertyInspection";
import ContactPropertyOwner from "./components/contactPropertyOwner";
import NoReplyFromOwner from "./components/noReplyFromOwner";
import NotifyTenantProcess from "./components/notifyTenantProcess";
import OwnerSellingproperty from "./components/ownerSellingProperty";
import SendRenewalOffer from "./components/sendRenewalOffer";
import TenantVacating from "./components/tenantVacating";
import SectionEightRenewal from "./components/sectionEightRenewal";
import RenewalFollowUp from "./components/renewalFollowUp";
import RenewalSigned from "./components/renewalSigned";
import MTMRenewal from "./components/MTMRenewal";
import NoReplyOnOffer from "./components/noReplyOnOffer";
import Completed from "./components/completed";

const LeaseRenewal = ({ itemId, listId, checkedItems }) => {
  return (
    <div>
      {itemId === 1 && (
        <ReviewPropertyInspection
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 2 && (
        <ContactPropertyOwner
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 3 && (
        <NoReplyFromOwner
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 4 && (
        <NotifyTenantProcess
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 5 && (
        <OwnerSellingproperty
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 6 && (
        <SendRenewalOffer
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 7 && (
        <TenantVacating
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 8 && (
        <SectionEightRenewal
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 9 && (
        <RenewalFollowUp
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 10 && (
        <RenewalSigned
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 11 && (
        <MTMRenewal
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 12 && (
        <NoReplyOnOffer
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 13 && (
        <Completed
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
    </div>
  );
};

export default LeaseRenewal;
